export default __webpack_public_path__ + "static/iphone-09d7c00b169dfa903bda7a60ad14823f.jpg";